import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { siteData } from '../data/content';

const Contact = () => {
  return (
    <div className="pt-24 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-slate-800 mb-4">聯絡我們與登島申請</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            有任何行程問題或需要協助申請登島，歡迎透過以下方式與我們聯繫，我們將有專人為您服務。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-white rounded-2xl shadow-md p-8 mb-8 border-t-4 border-blue-500">
              <h2 className="text-2xl font-bold text-slate-800 mb-6 flex items-center">
                <SafeIcon name="Headphones" className="text-blue-500 mr-3" />
                線上客服資訊
              </h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 mt-1">
                    <SafeIcon name="Phone" className="text-blue-600" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-sm font-medium text-slate-500">服務專線</h3>
                    <p className="text-lg text-slate-800 font-semibold">{siteData.mobile1} (吳先生)</p>
                    <p className="text-slate-600">{siteData.mobile2}</p>
                    <p className="text-slate-600">{siteData.phone} (市話)</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-1">
                    <SafeIcon name="MessageCircle" className="text-green-600" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-sm font-medium text-slate-500">LINE ID</h3>
                    <p className="text-lg text-slate-800 font-semibold">{siteData.lineId}</p>
                    <a href="https://line.me/ti/p/J2MCDvI-Tu" target="_blank" rel="noreferrer" className="text-sm text-blue-500 hover:underline">點此加入好友</a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0 mt-1">
                    <SafeIcon name="MessageSquare" className="text-green-500" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-sm font-medium text-slate-500">WeChat ID</h3>
                    <p className="text-lg text-slate-800 font-semibold">{siteData.wechatId}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-md p-8 border-t-4 border-orange-400">
              <h2 className="text-2xl font-bold text-slate-800 mb-6 flex items-center">
                <SafeIcon name="CreditCard" className="text-orange-500 mr-3" />
                匯款資訊
              </h2>
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-100">
                <ul className="space-y-4">
                  <li className="flex justify-between border-b border-slate-200 pb-2">
                    <span className="text-slate-500">戶名</span>
                    <span className="font-semibold text-slate-800">{siteData.bank.name}</span>
                  </li>
                  <li className="flex justify-between border-b border-slate-200 pb-2">
                    <span className="text-slate-500">銀行代碼</span>
                    <span className="font-semibold text-slate-800">{siteData.bank.code}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-slate-500">帳號</span>
                    <span className="font-bold text-blue-600 tracking-wider font-mono">{siteData.bank.account}</span>
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>

          {/* Contact / Apply Form (Mockup) */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-md p-8"
          >
            <h2 className="text-2xl font-bold text-slate-800 mb-6 flex items-center">
              <SafeIcon name="Edit3" className="text-blue-500 mr-3" />
              快速預約 / 留言
            </h2>
            <form className="space-y-5" onSubmit={(e) => e.preventDefault()}>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">姓名</label>
                <input type="text" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow" placeholder="請輸入您的姓名" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">聯絡電話</label>
                <input type="tel" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow" placeholder="請輸入手機號碼" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">有興趣的行程</label>
                <select className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow bg-white">
                  <option>賞鯨 + 龜山八景 (二合一)</option>
                  <option>登島 + 龜山八景 (二合一)</option>
                  <option>賞鯨 + 登島 + 龜山八景 (三合一)</option>
                  <option>401高地 + 登島 + 龜山八景</option>
                  <option>其他問題諮詢</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">預計日期</label>
                <input type="date" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">留言內容</label>
                <textarea rows="4" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-shadow resize-none" placeholder="請輸入您的問題或需求，例如登島人數等..."></textarea>
              </div>
              <button type="button" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-lg transition-colors shadow-md mt-4">
                送出訊息 (僅供示範)
              </button>
              <p className="text-xs text-center text-slate-500 mt-4">
                * 真實預約建議直接撥打電話或加入 LINE 客服處理速度最快。
              </p>
            </form>
          </motion.div>

        </div>
      </div>
    </div>
  );
};

export default Contact;